<app-navbar [nameSection]="name"></app-navbar>

<div class="container-fluid">
    @if (message) {
        <p class="pending-message mt-3">{{ message }}</p>
    }

    @if (loaded && photos.length === 0) {
        <p class="pending-empty mt-3">No hay fotos pendientes de enviar.</p>
    }

    <div class="mb-3 row">
        <div *ngFor="let photo of photos" class="col-12 col-md-6 mt-3">
            <div class="card">
                <img *ngIf="photo.preview" [src]="photo.preview" alt="" class="card-img-top pending-preview">
                <div *ngIf="!photo.preview" class="card-img-top text-center p-4">
                    <i class="fa fa-image fa-4x"></i>
                </div>

                <div class="card-body">
                    <p class="mb-1"><strong>{{ typeLabel(photo.image) }}</strong> · Albarán {{ photo.image.albara }}</p>
                    @if (photo.image.attempts) {
                        <p class="mb-1">Intentos fallidos: {{ photo.image.attempts }}
                            @if (photo.image.lastAttemptOn) {
                                (último {{ photo.image.lastAttemptOn | date:'dd/MM HH:mm' }})
                            }
                        </p>
                    }
                    @if (photo.image.lastError) {
                        <p class="mb-1 pending-error">{{ photo.image.lastError }}</p>
                    }
                </div>

                <div class="card-footer">
                    @if (!photo.confirmDelete) {
                        <div class="pending-actions">
                            <button (click)="resend(photo)" [disabled]="photo.sending || dbService.uploadingImages || !dbService.isSendable(photo.image)"
                                    class="btn pending-resend">
                                <i class="fa fa-paper-plane"></i>
                                {{ photo.sending ? 'Enviando…' : 'Reenviar' }}
                            </button>
                            <button (click)="photo.confirmDelete = true" [disabled]="photo.sending || dbService.uploadingImages" class="btn pending-delete">
                                <i class="fa fa-trash"></i>
                                Eliminar
                            </button>
                        </div>
                    } @else {
                        <p class="mb-2">Si la eliminas no se enviará nunca. ¿Seguro?</p>
                        <div class="pending-actions">
                            <button (click)="remove(photo)" class="btn pending-delete">Sí, eliminar</button>
                            <button (click)="photo.confirmDelete = false" class="btn pending-cancel">No</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
